var _defs, _path, _polygon, _rect, _polygon2, _polygon3, _polygon4, _path2, _polygon5, _polygon6, _path3, _polygon7, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.92 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.99,6.43c-15.79,0-28.59,12.75-28.59,28.48,0,6.79,2.39,13.03,6.38,17.92l-6.38,10.56,11.61-5.57c4.75,3.49,10.62,5.57,16.98,5.57,15.79,0,28.59-12.75,28.59-28.48s-12.8-28.48-28.59-28.48M183.84,43.94c-5.01,2.12-10.79-.21-12.91-5.2-2.12-4.99.21-10.75,5.22-12.86,5.01-2.12,10.79.21,12.91,5.2,2.12,4.99-.21,10.75-5.22,12.86"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.33 63.39 10.33 41 26.24 41 26.24 45.09 15.12 45.09 15.12 49.96 26.01 49.96 26.01 54.06 15.12 54.06 15.12 63.39 10.33 63.39"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.58,
    y: 41,
    width: 4.79,
    height: 22.4
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.32 63.39 43.6 48.35 43.6 63.39 38.81 63.39 38.81 41 43.73 41 54.15 55.5 54.15 41 58.93 41 58.93 63.39 54.32 63.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.57 63.39 68.57 45.19 62 45.19 62 41 79.93 41 79.93 45.19 73.39 45.19 73.39 63.39 68.57 63.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83 63.39 83 41 98.91 41 98.91 45.09 87.78 45.09 87.78 49.96 98.67 49.96 98.67 54.06 87.78 54.06 87.78 59.26 98.91 59.26 98.91 63.39 83 63.39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.57,52.21c0-6.88,5.22-11.58,11.8-11.58,5.12,0,7.99,2.69,9.57,5.47l-4.11,2.01c-.94-1.81-2.97-3.26-5.46-3.26-3.91,0-6.88,3.12-6.88,7.35s2.97,7.35,6.88,7.35c2.49,0,4.52-1.41,5.46-3.26l4.11,1.98c-1.62,2.79-4.45,5.51-9.57,5.51-6.57,0-11.8-4.7-11.8-11.58"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.21 63.39 141.21 53.99 130.59 53.99 130.59 63.39 125.8 63.39 125.8 41 130.59 41 130.59 49.79 141.21 49.79 141.21 41 146.03 41 146.03 63.39 141.21 63.39"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.1 14.26 72.75 14.26 72.75 12.52 89.4 12.52 89.4 14.26 82.06 14.26 82.06 34.91 80.1 34.91 80.1 14.26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.15,29.41h-11.97l-2.26,5.51h-2.16l9.2-22.39h2.39l9.2,22.39h-2.16l-2.26-5.51ZM93.79,27.66h10.75l-5.39-13.26-5.36,13.26Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.86 12.52 114.78 12.52 114.78 33.17 125.67 33.17 125.67 34.91 112.86 34.91 112.86 12.52"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.27 24.37 131.77 27.09 131.77 34.91 129.85 34.91 129.85 12.52 131.77 12.52 131.77 24.77 142.62 12.52 145.09 12.52 135.51 23.2 146 34.91 143.53 34.91 134.27 24.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTft);
export default __webpack_public_path__ + "static/media/White TFT.cbfc0b799c692417cce669e20a171ce4.svg";
export { ForwardRef as ReactComponent };